<template>
  <section id="report-footer-information">
    <div class="footer-report-number">
      <h3 class="footer-heading">
        {{ data.accession_id }} - {{ data.patient_first_name }},
        {{ data.patient_last_name }} - Reported
        {{ momentWithTimezone(data.reported_date, "MMM DD, yyyy, hh:mm A") }}
      </h3>
    </div>
    <table class="footer-table">
      <tr style="vertical-align: middle">
        <td>
          <p>
            The information contained in this report is intended to be
            interpreted by a licensed physician or other licensed healthcare
            professional and not a substitute for professional medical advice,
            diagnosis, or treatment. Only a physician, pharmacist or other
            healthcare professional should advise a patient on the use of the
            medications prescribed.
          </p>
        </td>
        <td>
          <div class="footer-company-logo">
            <img src="@/assets/img/new-logo.png" width="80" />
          </div>
        </td>
      </tr>
    </table>
  </section>
</template>

<script>
export default {
  props: ["reportsData"],
  data() {
    return {
      data: {
        patient_first_name: "",
        patient_last_name: "",
        accession_id: "",
        reported_date: "",
        dateFormat: "MMM DD, YYYY, HH:mm",
      },
    };
  },
  mounted() {
    if (this.reportsData) {
      this.setData();
    }
  },
  methods: {
    setData() {
      this.data = {
        patient_first_name: this.reportsData.patient_demographics
          ? this.reportsData.patient_demographics.givenName
          : "",
        patient_last_name: this.reportsData.patient_demographics
          ? this.reportsData.patient_demographics.sn
          : "",
        accession_id: this.reportsData.sample_name,
      };

      this.data.reported_date = this.reportsData.updated_at;
    },
  },
};  
</script>

<style lang="scss" scoped>
#report-footer-information {
  .footer-report-number {
    h3 {
      background: #e5f5fb;
      padding: 4px 10px;
      font-size: 1.3em;
      color: #2b5e76;
      font-weight: normal;
      margin-bottom: 25px;
    }
  }
}
.footer-table {
  tr {
    td p {
      line-height: 20px;
    }
    td:nth-child(1) {
      width: 80%;
    }
  }
  .footer-company-logo {
    margin-left: 60px;
    img {
      width: 80px;
    }
  }
  .description {
    margin-top: 0;
  }

  .footer-heading {
    background-color: #ecf7fa;
    padding: 3px 10px;
  }

  .report-date {
    font-size: 1.2em;
    font-weight: 500;
    .footer-description p {
      font-size: 13px;
      margin: 0;
    }
  }
}

.table-type2 {
  .each-result {
    table {
      border-radius: 0;
      tr:first-child td {
        background: #e3f5f9;
        color: #184f68;
        font-size: 1em;
        font-weight: 400;
        padding: 5px 15px;
      }
    }
  }
}
</style>
